import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IPersonListState, PersonListState } from "./states.store";
import { PersonServices } from "../../../services/person.services";
import actions from "./actions.store";
import getters from "./getters.store";
import mutations from "./mutations.store";

/**
 * person proposal module
 */
import proposalActions from "./proposal/actions.store";
import proposalGetters from "./proposal/getters.store";
import proposalMutations from "./proposal/mutations.store";

export class PersonListModule<RootState>
	implements Module<IPersonListState, RootState> {
	namespaced: boolean;
	state: IPersonListState;
	getters: GetterTree<IPersonListState, RootState>;
	actions: ActionTree<IPersonListState, RootState>;
	mutations: MutationTree<IPersonListState>;

	/**
	 *
	 */
	constructor() {
		this.namespaced = true;
		this.state = new PersonListState({
			service: new PersonServices(),
			searchParam: {}
		});
		this.mutations = {
			...mutations,
			...proposalMutations,
		};
		this.actions = {
			...actions,
			...proposalActions,
		};
		this.getters = {
			...getters,
			...proposalGetters,
		};
	}
}
